import { Button } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import { inAppNotificationKeys } from "../../../../api/queryKeys";
import CustomToolTip from "../../../../components/CustomTooltip";
import { Toast } from "../../../../components/Toast";

const CreateInAppNotification = () => {
  const colors = useColors();
  const { createDummyInAppNotifications } = useAPI();
  const queryClient = useQueryClient();
  const handleOnClick = () => {
    createDummyInAppNotifications()
      .then(() => {
        Toast.success("Create dummy Inbox notifications");
        queryClient.invalidateQueries({ queryKey: inAppNotificationKeys.all });
      })
      .catch(() => {
        Toast.error("Error create in app notification");
      });
  };

  return (
    <>
      <CustomToolTip title="Create in app notification">
        <Button
          variant="outlined"
          sx={{
            backgroundColor: colors.secondary_main,
            "&:hover": {
              backgroundColor: colors.secondary_dark,
            },
          }}
          onClick={handleOnClick}
        >
          create dummy inbox notifications
        </Button>
      </CustomToolTip>
    </>
  );
};

export default CreateInAppNotification;
